export default {
	name: 'inquiry_import',
	data() {
		return  {
			message: '请核对EXCEL格式内容后，再重新提交'
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/home/inquiry/import/index.js